"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Mark =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Mark, _React$Component);

  function Mark() {
    _classCallCheck(this, Mark);

    return _possibleConstructorReturn(this, _getPrototypeOf(Mark).apply(this, arguments));
  }

  _createClass(Mark, [{
    key: "isMarkActive",
    value: function isMarkActive(value) {
      return value <= this.props.upperBound && value >= this.props.lowerBound;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          step = _this$props.step,
          min = _this$props.min,
          max = _this$props.max;
      var range = max - min;
      var elements = [];

      if (this.props.step) {
        for (var i = min + step; i < max; i = i + step) {
          var offset = "".concat(Math.abs(i - min) / range * 100, "%");
          var style = {
            left: offset
          };
          var extraClass = this.isMarkActive(i) ? 'active' : '';
          elements.push(_react.default.createElement("div", {
            className: (0, _classnames.default)("".concat(_ThemeManager.default.getVar('classPrefix'), "-slider-dot"), extraClass),
            style: style,
            key: i
          }));
        }
      }

      return _react.default.createElement("div", {
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-slider-step")
      }, elements);
    }
  }]);

  return Mark;
}(_react.default.Component);

exports.default = Mark;
Mark.defaultProps = {
  max: 100,
  min: 0
};
Mark.propTypes = {
  /**
   * Minimum value of the slider
   */
  min: _propTypes.default.number,

  /**
   * Maximum value of the slider
   */
  max: _propTypes.default.number,

  /**
   * Step interval of the slider
   */
  step: _propTypes.default.number,

  /**
   * LowerBound of the active area on the rail
   */
  lowerBound: _propTypes.default.number,

  /**
   * UpperBound of the active area on the rail
   */
  upperBound: _propTypes.default.number
  /**
   *
   * @param {number} value - Number value of a mark on the rail.
   * @return {Boolean} - if value is within active area.
   */

};